
define('text!templates/widgets/formControls/cancel.html',[],function () { return '<a class="btn btn-link cancel-action" data-bind="\n    lString: label,\n    attr: {\n        id: id,\n        href: href\n    }\n"></a>';});

